module.exports = __webpack_public_path__ + "static/media/Order.1e37b655.png";